"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalizeEach = void 0;
/**
 * Capitalizes each individual word in a string.
 * @param text A string to format.
 */
var capitalizeEach = function (text) {
    return text
        .toLowerCase()
        .split(' ')
        .map(function (s) { return s.charAt(0).toUpperCase() + s.substring(1); })
        .join(' ');
};
exports.capitalizeEach = capitalizeEach;
